<template>
  <div class="list scroll-list" @scroll="onScroll">
    <div class="weui-loadmore" v-if="pullTop" :style="'margin:'+moveDistance+'px auto;'">
      <span class="weui-loadmore__tips">
        <span class="iconfont icon-refresh"></span>
        {{refreshing?'正在刷新':(pullTopReady?'释放刷新':'下拉刷新')}}
      </span>
    </div>
    <div class="scroll-body" ref="content">
      <div class="weui-cells">
        <slot></slot>
      </div>
      <slot name="bbar"></slot>
      <div
        class="weui-loadmore"
        v-if="pullBottom"
        :style="'margin:20px auto ' + (moveDistance + marginBottom) + 'px'"
      >
        <span class="weui-loadmore__tips">
          <span class="iconfont icon-refresh"></span>
          {{loading?'正在加载':(pullBottomReady?'释放加载':'加载更多')}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      /**
       * 顶部下拉
       */
      pullTop: false,
      /**
       * 顶部下拉distance>=20后，达到释放即刷新的条件
       */
      pullTopReady: false,
      /**
       * 顶部下拉释放后，开始刷新
       */
      refreshing: false,
      /**
       * 底部上拉
       */
      pullBottom: false,
      /**
       * 底部上拉distance>=20后，达到释放即刷新的条件
       */
      pullBottomReady: false,
      /**
       * 底部上拉释放后，开始加载下一页
       */
      loading: false,
      bodyTop: 0,
      bodyBottom: 0,
      startScreenY: 0,
      moveDistance: 0,
      scrollTop: 0,
      scrollBottom: 0,
      marginBottom: 0,
    };
  },
  mounted() {
    var me = this;
    me.$nextTick(() => {
      me.init();
    });
  },
  methods: {
    init() {
      var me = this,
        content = me.$refs.content,
        rect = content.getBoundingClientRect();
      me.bodyTop = rect.top;
      me.bodyBottom = rect.bottom;
      // scroll-list距离底部距离
      me.marginBottom =
        window.innerHeight - content.parentNode.getBoundingClientRect().bottom;
      me.scrollTop = rect.top;
      me.scrollBottom = rect.bottom;
      content.addEventListener("touchstart", me.handleTouchStart);
      content.addEventListener("touchmove", me.handleTouchMove);
      content.addEventListener("touchend", me.handleTouchEnd);
    },
    onScroll() {
      var me = this,
        content = me.$refs.content,
        rect = content.getBoundingClientRect();
      me.scrollTop = rect.top;
      me.scrollBottom = rect.bottom;
    },
    handleTouchStart(e) {
      var me = this;
      if (!me.isTop() && !me.isBottom()) {
        return;
      }
      if (me.refreshing || me.loading) {
        return;
      }
      me.startScreenY = e.touches[0].screenY;
    },
    isTop() {
      var me = this,
        content = me.$refs.content,
        top = content.getBoundingClientRect().top;
      return (
        top >= me.bodyTop && (me.scrollTop == 0 || me.scrollTop == me.bodyTop)
      );
    },
    isBottom() {
      var me = this,
        content = me.$refs.content,
        bottom = content.getBoundingClientRect().bottom;
      return (
        parseInt(bottom) <= parseInt(me.bodyBottom) &&
        (parseInt(me.scrollTop) <= 0 || parseInt(me.scrollBottom) == parseInt(me.bodyBottom))
      );
    },
    handleTouchMove(e) {
      var me = this,
        isTop = me.isTop(),
        isBottom = me.isBottom();
      if (!isTop && !isBottom) {
        return;
      }
      if (me.refreshing || me.loading) {
        return;
      }
      var screenY = e.touches[0].screenY;
      // 实际展示出来的distance按 1:4 缩小展示
      let moveDistance = (screenY - me.startScreenY) / 4;
      if (isTop && moveDistance > 0) {
        me.moveDistance = moveDistance;
        me.pullTop = true;
        if (moveDistance > 10) {
          me.pullTopReady = true;
        } else {
          me.pullTopReady = false;
        }
      } else if (isBottom && moveDistance < 0) {
        me.moveDistance = -moveDistance;
        me.pullBottom = true;
        if (moveDistance < -10) {
          me.pullBottomReady = true;
        } else {
          me.pullBottomReady = false;
        }
        // 滚动到最底部
        me.$nextTick(() => {
          var scrollList = me.$refs.content.parentNode;
          scrollList.scrollTop = scrollList.scrollHeight;
        });
      } else {
        me.clearState();
      }
    },
    handleTouchEnd() {
      var me = this;
      if (!me.isTop() && !me.isBottom()) {
        if (me.pullTop || me.pullBottom) {
          me.clearState();
        }
        return;
      }
      if (me.refreshing || me.loading) {
        return;
      }
      if (me.pullTopReady) {
        me.refreshing = true;
        me.$emit("refresh", () => {
          me.clearState();
        });
      } else if (me.pullBottomReady) {
        me.loading = true;
        me.$emit("loadpage", () => {
          me.clearState();
        });
      } else {
        me.clearState();
      }
    },
    clearState() {
      var me = this;
      me.moveDistance = 0;
      me.pullTop = false;
      me.pullTopReady = false;
      me.refreshing = false;
      me.pullBottom = false;
      me.pullBottomReady = false;
      me.loading = false;
    },
  },
};
</script>

<style>
.scroll-list {
  flex: 1;
}
.scroll-list .scroll-body {
  min-height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.scroll-list .weui-cells {
  margin-top: 0;
}
.scroll-list .weui-cells:before {
  display: none;
}
</style>